import React, { ReactNode } from 'react';
interface IProps {
	children: ReactNode;
}

export const ListFooter: React.FC<IProps> = ({ children }) => {
	return <div className=' bg-gray-100 py-4  '>{children}</div>;
};
